<template>
  <van-pull-refresh v-model="isRefresh" :head-height="80" @refresh="onRefresh">
    <div :style="{ height: height }">
      <van-list v-model="loading" :finished="finished" @load="onLoad">
        <div
          class="adInfo whiteBg"
          v-for="(item, index) in list"
          :key="index"
          @click="handleSelect(item)"
        >
          <div class="infoTitle">
            <div class="type" style="min-width: 32px;">
              {{ '驿站' }}
            </div>
            <div style="padding: 0 10px;">{{ item.siteName }}</div>
            <div class="text">{{ item.dis | formatDis }}</div>
          </div>
          <div class="support">详细地址：{{ item.siteAddress }}</div>
          <div class="support">
            营业时间：{{ item.siteOpenTime + '~' + item.siteCloseTime }}
          </div>
        </div>
      </van-list>
      <van-empty
        description="抱歉！您附近暂时没有可寄件的服务点"
        v-if="list.length === 0 && searchKey === ''"
      />
      <van-empty
        image="search"
        description="没有找到匹配的服务点"
        v-if="list.length === 0 && searchKey !== ''"
      />
    </div>
  </van-pull-refresh>
</template>
<script>
export default {
  props: {
    active: Number,
    cilentHeight: Number
  },
  filters: {
    formatDis(dis) {
      if (dis >= 1000) {
        return (dis / 1000).toFixed(2) + 'km'
      } else {
        return dis + 'm'
      }
    }
  },
  data() {
    return {
      type: '',
      height: 0,
      isRefresh: false,
      loading: false,
      finished: false,
      currentPage: 0,
      list: [],
      searchKey: ''
    }
  },
  created() {
    this.height = this.cilentHeight - 56 + 'px'
  },
  methods: {
    handleSelect(item) {
      this.$store.commit('set_selectedService', item)
      this.$store.commit('set_selectedExpress', {})
      this.$router.go(-1)
      // window.history.go(-1)
    },
    getList() {
      let location = JSON.parse(localStorage.getItem('location'))
      let params = {
        myLng: location.longitude,
        myLat: location.latitude,
        pageNum: this.currentPage,
        pageSize: 10
      }
      if (this.searchKey) {
        params = Object.assign(params, { name: this.searchKey })
      }
      let data = this.$Base64.encode(JSON.stringify(params))
      this.$api
        .getPostStageList(data)
        .then(res => {
          // console.log(res)
          this.loading = false
          this.isRefresh = false
          if (res.code === 0) {
            this.list = this.list.concat(res.data.rows)

            if (
              res.data.rows.length === 0 ||
              this.list.length >= res.data.totalCount
            ) {
              this.finished = true // 全部数据加载完了
            } else {
              this.finished = false
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.isRefresh = false
          this.finished = true
        })
    },
    onLoad() {
      this.currentPage++
      this.getList()
    },
    onRefresh() {
      this.currentPage = 1
      this.list = []
      this.getList()
    },
    handleSearch(key) {
      this.searchKey = key
      this.onRefresh()
    }
  }
}
</script>
<style lang="scss" scoped>
.adInfo {
  position: relative;
  margin: 10px;
  padding: 5px;
  //   height: 82px;
  border-radius: 5px;
  .infoTitle {
    height: 36px;
    display: flex;
    align-items: center;
    font-size: 14px;
    .type {
      height: 16px;
      padding: 4px;
      color: #fff;
      font-size: 12px;
      text-align: center;
      line-height: 16px;
      border-radius: 6px;
      background-color: #000;
    }
    .text {
      flex: 1;
      padding: 0 10px;
      border-left: 1px solid #ccc;
    }
  }
  .support {
    padding: 2px 0;
    width: calc(100% - 40px);
    font-size: 12px;
    color: #7f7f7f;
  }
}
.van-pull-refresh {
  height: calc(100vh - 56px) !important;
  overflow: auto !important;
}
</style>
